module.exports = __webpack_public_path__ + "static/media/AWS-Lambda-logo.a45ed9af.png";